import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import {Template, PageRequest, PageResponse, Page} from '../models/template.model';

@Injectable({
  providedIn: 'root'
})

export class ContractRestService {
  private http = inject(HttpClient);
  private readonly apiUrl = environment.apiRestUrl;

  async getTemplates(pageRequest: PageRequest): Promise<PageResponse<Template>> {
    let params = new HttpParams()
      .set('page', pageRequest.page.toString())
      .set('size', pageRequest.size.toString());

    if (pageRequest.sort && pageRequest.sort.length > 0) {
      pageRequest.sort.forEach(sortParam => {
        params = params.append('sort', sortParam);
      });
    }

    return firstValueFrom(
      this.http.get<PageResponse<Template>>(`${this.apiUrl}/admin/templates`, { params })
    );
  }

  async getAllTemplates(pageRequest: PageRequest, search?: string, company?: string): Promise<PageResponse<Template>> {
    console.log("searching over all temps")
    let params = new HttpParams()
      .set('page', pageRequest.page.toString())
      .set('size', pageRequest.size.toString());

    if (pageRequest.sort && pageRequest.sort.length > 0) {
      pageRequest.sort.forEach(sortParam => {
        params = params.append('sort', sortParam);
      });
    }

    if(search) {
      params = params.append('search', search)
    }

    if(company) {
      params = params.append('company', company)
    }

    return firstValueFrom(
      this.http.get<PageResponse<Template>>(`${this.apiUrl}/templates`, { params })
    );
  }

  async createTemplate(template: Partial<Template>): Promise<Template> {
    return firstValueFrom(
      this.http.post<Template>(`${this.apiUrl}/admin/templates`, template)
    );
  }

  async getTemplateById(id: number): Promise<Template> {
    return firstValueFrom(
      this.http.get<Template>(`${this.apiUrl}/templates/${id}`)
    );
  }

  async updateTemplate(template: Partial<Template>): Promise<Template> {
    return firstValueFrom(
      this.http.put<Template>(`${this.apiUrl}/admin/templates/update`, template)
    );
  }

  async deleteTemplate(id: string): Promise<void> {
    await firstValueFrom(
      this.http.delete<void>(`${this.apiUrl}/admin/templates/${id}`)
    );
  }

  async createPage(page: Partial<Page>): Promise<Page> {
    return firstValueFrom(
      this.http.post<Page>(`${this.apiUrl}/admin/pages`, page)
    );
  }

  async updatePage(page: Partial<Page>): Promise<Page> {
    return firstValueFrom(
      this.http.put<Page>(`${this.apiUrl}/admin/pages`, page)
    );
  }

  async deletePage(id: number): Promise<void> {
    return firstValueFrom(
      this.http.delete<void>(`${this.apiUrl}/admin/pages/${id}`)
    );
  }

  async sortPages(pages: any[]): Promise<void> {
    return firstValueFrom(
      this.http.put<void>(`${this.apiUrl}/admin/pages/sort`, {sorting: pages})
    );
  }

  loadTemplate(name: string) {
    return this.http.get(`assets/templates/${name}`, { responseType: 'text' })
  }


  async getContracts(pageRequest: PageRequest, search?: string, company?: string): Promise<PageResponse<Template>> {
    let params = new HttpParams()
    .set('page', pageRequest.page.toString())
    .set('size', pageRequest.size.toString());

    if (pageRequest.sort && pageRequest.sort.length > 0) {
      pageRequest.sort.forEach(sortParam => {
        params = params.append('sort', sortParam);
      });
    }

    if(search) {
      params = params.append('search', search)
    }

    return firstValueFrom(
      this.http.get<PageResponse<Template>>(`${this.apiUrl}/contract`, { params })
    );
  }

  loadLogo(logo: string) {
    return this.http.get(logo, { responseType: 'blob' });
  }

  loadImage(png: string) {
    return this.http.get(png, { responseType: 'blob' });
  }
}
